import React from "react";
import "./FAQ.css";

export default function FAQ() {
  const faqs = [
    {
      category: "Getting Started",
      questions: [
        {
          q: "How do I create an account?",
          a: "Click 'Get Started' or 'Sign Up' on the homepage, fill in your details, and verify your email address."
        },
        {
          q: "Is Go With Me Buddy free to use?",
          a: "Yes! Creating an account and connecting with travel partners is completely free."
        },
        {
          q: "What information do I need to provide?",
          a: "Basic information like name, email, travel interests, and preferred destinations to help match you with compatible partners."
        }
      ]
    },
    {
      category: "Finding Partners",
      questions: [
        {
          q: "How do I find travel partners?",
          a: "Use the 'Find Partner' feature to browse travelers with similar interests and destinations. Filter by location, dates, and travel style."
        },
        {
          q: "How does the matching algorithm work?",
          a: "We match users based on destination preferences, travel dates, interests, and compatibility factors."
        },
        {
          q: "Can I connect with multiple partners?",
          a: "Yes! You can send connection requests to as many compatible travelers as you'd like."
        }
      ]
    },
    {
      category: "Travel Agencies",
      questions: [
        {
          q: "How do I find travel agencies?",
          a: "Browse the 'Agencies' section to discover verified travel companies offering group tours and packages."
        },
        {
          q: "Are agencies verified?",
          a: "Yes, all agencies on our platform go through a verification process to ensure legitimacy."
        },
        {
          q: "How do I book with an agency?",
          a: "Contact agencies directly through their profile. We facilitate the connection, but bookings are made directly with the agency."
        }
      ]
    },
    {
      category: "Safety & Security",
      questions: [
        {
          q: "How do you ensure user safety?",
          a: "We verify user identities, provide safety guidelines, offer ratings and reviews, and have reporting mechanisms for suspicious activity."
        },
        {
          q: "Can I report suspicious users?",
          a: "Yes, every profile has a report option. Our team reviews all reports promptly."
        },
        {
          q: "What should I do before meeting a travel partner?",
          a: "Always communicate through the platform first, share your itinerary with trusted contacts, and meet in public places initially."
        }
      ]
    },
    {
      category: "Ratings & Reviews",
      questions: [
        {
          q: "How do ratings work?",
          a: "After completing a trip, you can rate your travel partner or agency on a 5-star scale with optional feedback."
        },
        {
          q: "Can I change my rating?",
          a: "Ratings are generally final to maintain authenticity, but you can contact support for exceptional circumstances."
        },
        {
          q: "Who can see my ratings?",
          a: "Your average rating is visible on your profile to all users. Individual ratings are visible to those you've traveled with."
        }
      ]
    },
    {
      category: "Account Management",
      questions: [
        {
          q: "How do I update my profile?",
          a: "Go to your profile page and click 'Edit Profile' to update your information, preferences, and photo."
        },
        {
          q: "Can I delete my account?",
          a: "Yes, you can delete your account from your profile settings. This action is permanent and cannot be undone."
        },
        {
          q: "I forgot my password. What should I do?",
          a: "Click 'Forgot Password' on the login page and follow the instructions to reset your password via email."
        }
      ]
    }
  ];

  return (
    <div className="faq-page">
      <div className="faq-container">
        <div className="faq-header">
          <h1>Frequently Asked Questions</h1>
          <p>Find answers to common questions about Go With Me Buddy</p>
        </div>

        <div className="faq-content">
          {faqs.map((category, idx) => (
            <div key={idx} className="faq-category">
              <h2 className="category-title">{category.category}</h2>
              <div className="questions-list">
                {category.questions.map((item, qIdx) => (
                  <div key={qIdx} className="faq-item">
                    <h3 className="question">{item.q}</h3>
                    <p className="answer">{item.a}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="faq-footer">
          <h3>Still have questions?</h3>
          <p>Visit our <a href="/help">Help Center</a> or contact us at <a href="mailto:gowithmebuddy1@gmail.com">gowithmebuddy1@gmail.com</a></p>
        </div>
      </div>
    </div>
  );
}
